import React, { useEffect, useState } from "react";
import { url } from "../../Constant";
import axios from "axios";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
// import FilterModal from "../../components/Modal/FilterModal";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import FilterModalMissedCall from "../../components/Modal/FilterModalMissedCall";
import { message } from "antd";

const NewMissedCalls = () => {
  const accessVpbxId = sessionStorage.getItem("companyData");
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [offtimeData, setOffTimeData] = useState([]);
  const [callerId, setCallerId] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [apicalled, setApiCalled] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateError, setDateError] = useState("");
  const [error, setError] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(false);
  // const [filterData, setFilterData] = useState({
  //   start_date: null,
  //   end_date: null,
  //   duration_type: "",
  //   duration: null,
  //   condition: null,
  //   agent_number: "",
  //   customer_number: "",
  // });
  const [filterData, setFilterData] = useState({
    start_date: null,
    end_date: null,
    caller_id: "",
    message: "",
  });

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const handleOpenFilterModal = () => {
    setOpenFilterModal(true);
  };
  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const getOfftime = (page) => {
    let api = "";
    if (auth.role === "1") {
      api = `super_off_time_stats/${accessVpbxId}`;
    } else if (auth.role === "2") {
      api = `off_time_stats/${auth.vpbx_id}`;
    } else {
      api = `user-off_time_stats/${auth.vpbx_id}`;
    }

    axios
      .get(url + api, {
        params: {
          page: page,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          caller_id: filterData.caller_id,
          message: filterData.message,
        },

        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            if (
              response?.data?.message === "Data Not Found" &&
              response?.data?.data?.length === 0
            ) {
              setOffTimeData([]);
            } else if (response.data.message === "Data Found") {
              setOffTimeData(response?.data?.data?.off_time_data);
              setPageCount(response.data.data.pages);
              setCallerId(response?.data?.data?.call_status_msg);
            }
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };
  const getFilterData = (page) => {
    var Errorvariable = "";
    if (
      filterData.start_date === null &&
      filterData.end_date === null &&
      filterData.message === "" &&
      filterData.caller_id === ""
    ) {
      Errorvariable = "Please select parameters for filter";
      setError(Errorvariable);
    }
    if (Errorvariable === "" && dateError === "") {
      setLoader(true);
      let api = "";
      if (auth.role === "1") {
        api = `super_off_time_stats/${accessVpbxId}`;
      } else if (auth.role === "2") {
        api = `off_time_stats/${auth.vpbx_id}`;
      } else {
        api = `user-off_time_stats/${auth.vpbx_id}`;
      }
      axios
        .get(url + api, {
          params: {
            page: page,
            start_date: filterData.start_date,
            end_date: filterData.end_date,
            caller_id: filterData.caller_id,
            message: filterData.message,
          },

          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              setLoader(false);

              if (
                response.data.message === "Data Not Found" &&
                response.data.data.length === 0
              ) {
                setOffTimeData([]);
              } else if (response.data.message === "Data Found") {
                setOffTimeData(response.data.data.off_time_data);
                setPageCount(response.data.data.pages);
                setCallerId(response?.data?.data?.call_status_msg);
              }
              handleCloseFilterModal();
            }
          },
          (error) => {
            console.log(error);
          },
        );
    } else {
      setLoader(false);
    }
  };

  const filteredDataMissedCall = offtimeData?.filter((val) => {
    return (
      (val.caller_id &&
        val.caller_id.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.call_status &&
        val.call_status.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.call_datetime &&
        val.call_datetime.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    setDownloadLoader(true);
    let api = "";
    if (auth.role === "1") {
      api = "super-downloadCdrs";
    } else if (auth.role === "2") {
      api = "downloadCdrs";
    } else {
      api = "user-downloadCdrs";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
          call_type: "offtime",
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          message: filterData.message,
          caller_id: filterData.caller_id,
          // agent_number: filterData.agent_number,
          // customer_number: filterData.customer_number,
          // duration_type: filterData.duration_type,
          // duration: filterData.duration,
          // condition: filterData.condition,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setDownloadLoader(false);

            window.location.href = response.data.data;
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const handlePageChange = (data) => {
    setLoader(true);
    getOfftime(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };
  useEffect(() => {
    getOfftime(1);
  }, []);
  useEffect(() => {
    if (apicalled === true) {
      getOfftime(1);
    }
  }, [apicalled]);
  return (
    // <div className="dashboardWrp">
    //   <div className="uk-container uk-container-large">
    //     <div className="dashboardTop">
    //       <div uk-grid="" className="uk-grid uk-grid-small">
    //         <div className="uk-width-2-3">
    //           <div className="dashboardIntro">
    //             <h3>CALL RECORDS</h3>
    //             {auth.role === "2" && (
    //               <p>
    //                 Use this page to view the call logs or call history,
    //                 including inbound, outbound, and missed calls.
    //               </p>
    //             )}
    //           </div>
    //         </div>

    //         <div className="uk-width-1-1 ">
    //           <ul
    //             className="uk-subnav callSwitcher"
    //             uk-switcher="connect: .callClass"
    //           >
    //             {(auth.role === "2" || auth.role === "3") && (
    //               <>
    //                 {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //                   <li onClick={() => navigate("/incoming-calls")}>
    //                     <a href="#">Incoming calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //                   <li onClick={() => navigate("/outgoing-calls")}>
    //                     <a href="#">Outgoing calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //                   <li
    //                     className="uk-active"
    //                     onClick={() => navigate("/missed-calls")}
    //                   >
    //                     <a href="#">Offtime calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" ||
    //                 checkPermissions("ext-to-ext-calls") ? (
    //                   <li onClick={() => navigate("/ext-to-ext")}>
    //                     <a href="#">Ext. to Ext.</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.call_initiated === "1" ? (
    //                   <li onClick={() => navigate("/feedback")}>
    //                     <a href="#">Feedback</a>
    //                   </li>
    //                 ) : null}
    //               </>
    //             )}
    //           </ul>
    //         </div>
    //       </div>
    //       <ul className="uk-switcher uk-margin callClass">
    //         {(auth.role === "2" || auth.role === "3") && (
    //           <>
    //             {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //               <li>
    <div className="ImcomingCallMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            <div className="CustomSearch">
              <form className="uk-search uk-search-default">
                {/* <span uk-search-icon=""></span> */}

                <input
                  className="uk-search-input"
                  type="text"
                  placeholder="Search by all field"
                  value={searchText}
                  onChange={handleSearch}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                {(auth.role === "1" ||
                  auth.role === "2" ||
                  checkIndividualPermission(
                    "offtime-calls",
                    "read_and_write",
                  )) && (
                  <>
                    <button
                      className="exportData-button"
                      onClick={handleOpenFilterModal}
                      disabled={loader ? true : false}
                    >
                      Add Filter
                    </button>
                    <button
                      className="exportData-button"
                      onClick={handleExportData}
                    >
                      {downloadLoader ? (
                        <div uk-spinner=""></div>
                      ) : (
                        "Export Data"
                      )}
                    </button>
                  </>
                )}
              </div>
            </span>
            <span className="primary-color"></span>
          </div>
        </div>
      </div>
      {loader ? (
        <div uk-spinner="" className="tableloader"></div>
      ) : filteredDataMissedCall.length === 0 ? (
        <div className="customtableNoDataText">
          There are no records to display
        </div>
      ) : (
        <div className="customTable">
          <table>
            <thead>
              <tr>
                <th>MSISDN</th>
                <th>Message</th>
                <th>Date Time</th>
                <th>Call Recording</th>
              </tr>
            </thead>
            <tbody>
              {filteredDataMissedCall.map((val, index) => (
                <>
                  <tr key={index}>
                    <td>{val.caller_id}</td>
                    <td>{val.call_status}</td>
                    <td>{val.call_datetime}</td>
                    <td>
                      <audio
                        className="mp3Audio"
                        controls
                        target="_blank"
                        rel="noopener noreferrer"
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source
                          src={
                            process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                            `${auth.role === "1" ? accessVpbxId : auth.vpbx_id}/` +
                            moment(val.call_datetime).format("YYYYMMDD") +
                            "/" +
                            `${val.call_status === "voicemail_noanswer" ? "voicemail_noanswer" : "voicemail"}` +
                            "/" +
                            `${val.userfield}.wav`
                          }
                          // src={
                          //   process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                          //   `${auth.vpbx_id}/` +
                          //   moment(val.call_datetime).format("YYYYMMDD") +
                          //   "/" +
                          //   `${val.call_status === "voicemail_noanswer" ? "voicemail_noanswer" : "voicemail"}` +
                          //   "/" +
                          //   `${val.userfield}.wav`
                          // }
                        />
                        Your browser does not support the audio tag.
                      </audio>
                    </td>
                  </tr>
                  <br />
                </>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"...."}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          containerClassName={"uk-pagination uk-float-right contatPagination"}
          activeClassName={"uk-active"}
          marginPagesDisplayed={3}
          pageRangeDisplayed={6}
        />
      )}
      {/* {openFilterModal && (
        <FilterModal
          closeModal={handleCloseFilterModal}
          setFilterData={setFilterData}
          filterData={filterData}
          setApiCalled={setApiCalled}
          getFilterData={getFilterData}
          setDateError={setDateError}
          dateError={dateError}
          error={error}
          setError={setError}
        />
      )} */}
      {openFilterModal && (
        <FilterModalMissedCall
          closeModal={handleCloseFilterModal}
          setFilterData={setFilterData}
          filterData={filterData}
          setApiCalled={setApiCalled}
          getFilterData={getFilterData}
          setDateError={setDateError}
          dateError={dateError}
          error={error}
          setError={setError}
          callerId={callerId}
        />
      )}
    </div>
    //               </li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("ext-to-ext-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.call_initiated === "1" ? <li></li> : null}
    //           </>
    //         )}
    //       </ul>
    //     </div>
    //   </div>
    // </div>
  );
};

export default NewMissedCalls;
